import { registerModal } from 'features/Modal/ModalRegistry'
import { PhoneSystemNumberEditFormModal } from './PhoneSystemNumberEditFormModal'
import { showModal } from 'features/Modal/Modal.actions'
import { INumberFormData } from '../PhoneSystemNumberEditForm/PhoneSystemNumberEditForm.container'

export const modalType = 'PHONE_SYSTEM_NUMBER_EDIT_FORM_MODAL'
registerModal(modalType, PhoneSystemNumberEditFormModal)
export const showPhoneSystemNumberEditFormModal = (modalProps: INumberFormData) =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemNumberEditFormModal/PhoneSystemNumberEditFormModal.action.ts